export const isThicknessViewerLocation = (
  pathname: string,
  search: string,
): boolean =>
  pathname === '/cad-viewer' &&
  new URLSearchParams(search).get('mode') === 'thickness';

export const canSwitchCadThicknessMode = (
  thicknessEnabled: boolean | null,
): boolean => thicknessEnabled === true;

export const toggleCadViewerModeParams = (
  current: URLSearchParams,
  thicknessMode: boolean,
  selectedModelId?: string,
): URLSearchParams => {
  const next = new URLSearchParams(current);

  if (thicknessMode) {
    next.delete('mode');
    next.delete('model');
    next.delete('analysis');
    next.delete('region');
    return next;
  }

  next.set('mode', 'thickness');
  next.delete('analysis');
  next.delete('region');
  if (selectedModelId) next.set('model', selectedModelId);
  else next.delete('model');
  return next;
};
